import NEW_BOOKING_STEPS from 'constants/newBookingSteps';

const PRIVATE_CREMATION = Object.freeze({
    ownerPetDetails: NEW_BOOKING_STEPS.ownerPetDetails,
    productList: NEW_BOOKING_STEPS.productList,
    confirmation: NEW_BOOKING_STEPS.confirmation
});

export default PRIVATE_CREMATION;
